import humps from 'humps';
import { all, put, retry } from 'redux-saga/effects';
import { reject, resolve } from '../api';
import * as types from '../constants';
import { authClient } from '../api/Client';
import { NOTIFICATION } from '../constants';
import {
  errorNotification,
  showNotification,
  successNotification,
} from '../../shared-components/Notifications';

export function* loadIntegrations() {
  try {
    const res = yield retry(4, 500, authClient?.Integrations?.loadSplunk);

    yield put({
      type: resolve(types?.LOAD_SPLUNK),
      payload: humps?.camelizeKeys(res?.data()),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_SPLUNK),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.LOAD_SPLUNK)),
      }),
    ]);
  }
}

export function* updateIntegrations({ data, uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.Integrations?.updateSplunk, {
      uuid: uuid,
      body: data,
    });

    yield put({
      type: resolve(types?.UPDATE_SPLUNK),
      payload: humps?.camelizeKeys(res?.data()),
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Saving and connecting...',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.UPDATE_SPLUNK),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.UPDATE_SPLUNK)),
      }),
    ]);
  }
}

export function* saveIntegrations({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Integrations?.saveSplunk, {
      body: data,
    });

    yield put({
      type: resolve(types?.SAVE_SPLUNK),
      payload: humps?.camelizeKeys(res?.data()),
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Integration has been created',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.SAVE_SPLUNK),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.SAVE_SPLUNK)),
      }),
    ]);
  }
}

export function* deleteIntegrations({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.Integrations?.deleteSplunk, {
      uuid: uuid,
    });

    yield put({
      type: resolve(types?.DELETE_SPLUNK),
      payload: humps?.camelizeKeys(res?.data()),
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Integration has been deleted',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.DELETE_SPLUNK),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.DELETE_SPLUNK)),
      }),
    ]);
  }
}

export function* loadSlack() {
  try {
    const res = yield retry(4, 500, authClient?.Integrations?.loadSlack);

    yield put({
      type: resolve(types?.LOAD_SLACK),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_SLACK),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.LOAD_SLACK)),
      }),
    ]);
  }
}

export function* updateSlack({ data, uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.Integrations?.updateSlack, {
      uuid: uuid,
      body: data,
    });

    yield put({
      type: resolve(types?.UPDATE_SLACK),
      payload: res?.data(),
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Saving and connecting...',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.UPDATE_SLACK),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.UPDATE_SLACK)),
      }),
    ]);
  }
}

export function* saveSlack({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Integrations?.saveSlack, {
      body: data,
    });

    yield put({
      type: resolve(types?.SAVE_SLACK),
      payload: res?.data(),
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Integration has been created',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.SAVE_SLACK),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.SAVE_SLACK)),
      }),
    ]);
  }
}

export function* deleteSlack({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.Integrations?.deleteSlack, {
      uuid: uuid,
    });

    yield put({
      type: resolve(types?.DELETE_SLACK),
      payload: res?.data(),
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Integration has been deleted',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.DELETE_SLACK),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.DELETE_SLACK)),
      }),
    ]);
  }
}

export function* loadMTeams() {
  try {
    const res = yield retry(4, 500, authClient?.Integrations?.loadMTeams);

    yield put({
      type: resolve(types?.LOAD_M_TEAMS),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.LOAD_M_TEAMS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.LOAD_M_TEAMS)),
      }),
    ]);
  }
}

export function* updateMTeams({ data, uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.Integrations?.updateMTeams, {
      uuid: uuid,
      body: data,
    });

    yield put({
      type: resolve(types?.UPDATE_M_TEAMS),
      payload: res?.data(),
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Saving and connecting...',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.UPDATE_M_TEAMS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.UPDATE_M_TEAMS)),
      }),
    ]);
  }
}

export function* saveMTeams({ data }) {
  try {
    const res = yield retry(4, 500, authClient?.Integrations?.saveMTeams, {
      body: data,
    });

    yield put({
      type: resolve(types?.SAVE_M_TEAMS),
      payload: res?.data(),
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Integration has been created',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.SAVE_M_TEAMS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.SAVE_M_TEAMS)),
      }),
    ]);
  }
}

export function* deleteMTeams({ uuid }) {
  try {
    const res = yield retry(4, 500, authClient?.Integrations?.deleteMTeams, {
      uuid: uuid,
    });

    yield put({
      type: resolve(types?.DELETE_M_TEAMS),
      payload: res?.data(),
    });
    showNotification(
      successNotification({
        statusCode: 200,
        message: 'Integration has been deleted',
      }),
    );
  } catch (error) {
    yield all([
      put({
        type: reject(types?.DELETE_M_TEAMS),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(error, reject(types?.DELETE_M_TEAMS)),
      }),
    ]);
  }
}

export function* getAccessTokenBrowserling({ data }) {
  try {
    const res = yield retry(
      4,
      500,
      authClient?.Integrations?.getAccessTokenBrowserling,
      {
        body: data,
      },
    );

    yield put({
      type: resolve(types?.GET_ACCESS_TOKEN_BROWSERLING),
      payload: res?.data(),
    });
  } catch (error) {
    yield all([
      put({
        type: reject(types?.GET_ACCESS_TOKEN_BROWSERLING),
        error,
      }),
      put({
        type: NOTIFICATION?.ADD_NOTIFICATION,
        notification: errorNotification(
          error,
          reject(types?.GET_ACCESS_TOKEN_BROWSERLING),
        ),
      }),
    ]);
  }
}
